import React from 'react'
import Box from "@mui/material/Box";

import './CalculatePage.scss'
import {CalcPageInfo} from "./CalcPageInfo";
import classnames from "classnames";
import {LocationModal} from "../DealPage/LocationModal";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {useCalcContext} from "../../contexts/CalcContext";
import {LEASE_DEAL_LIGHT} from "../../contexts/DealContext";
import Button from "@mui/material/Button";
import ReplayIcon from '@mui/icons-material/Replay';
import {MiniLeadItem} from "../DealPage/DealCRMPage/MiniLeadItem";
import {useModalsStore} from "../../stores/modalsStore";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";

export const CalculatePage = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { calcState, resetCalcState, getLeadId } = useCalcContext()

    const isPurchase = calcState.is_purchase

    return (
        <Box id={"CalculatePage"}
             className={classnames('', {
                 isPurchase: isPurchase
             })}
        >
            <Stack
                justifyContent={'center'}
                style={{ width: '100%' }}
            >
                <Typography
                    gutterBottom
                    variant="h6"
                    component="div"
                    className={'header'}
                    sx={{
                        fontSize: '24px',
                        fontWeight: '400',
                        marginBottom: '10px',
                        color: "#666666",
                        whiteSpace: 'pre-wrap'
                    }}
                >
                    <Stack
                        justifyContent={isTabletOrMobile ? "space-between" : 'flex-start'}
                        direction="row"
                        alignItems={'center'}
                        sx={{
                            padding: isTabletOrMobile ? '0 22px 0 20px': '',
                        }}
                    >
                        <span>Calculate</span>
                        {
                            getLeadId() &&
                                <React.Fragment>
                                    <span> for lead</span>
                                    <MiniLeadItem leadId={getLeadId()}/>
                                </React.Fragment>
                        }
                        <Button
                            className={'calc-reset-button'}
                            style={{ background: '#2267CE' }}
                            onClick={resetCalcState}
                        >
                            Reset <ReplayIcon/>
                        </Button>
                    </Stack>
                </Typography>


                <CalcPageInfo />
            </Stack>
        </Box>
    )
}